import React from 'react';

import QualifyingField from '../QualifyingField';

import { HiddenFieldProps, HiddenFieldState } from './HiddenFieldProps.types';

class HiddenField extends React.Component<HiddenFieldProps, HiddenFieldState> {
  static getDerivedStateFromProps(nextProps: HiddenFieldProps): Partial<HiddenFieldState | null> {
    if (!nextProps.isValid || nextProps.isValid) {
      return { isValid: nextProps.isValid };
    } else return null;
  }

  constructor(props: HiddenFieldProps) {
    super(props);

    this.state = {
      isValid: true
    };
  }

  componentDidUpdate(prevProps: HiddenFieldProps, prevState: HiddenFieldState) {
    const { form, field } = this.props;
    const { isValid } = this.state;

    if (isValid !== prevState.isValid) {
      form.setFieldValue(field.name, isValid.toString(), true);
      form.validateField(field.name);
    }
  }

  render(): JSX.Element {
    const { field, form, recordDisqualification, disqualificationMessage, marginTopOffset } = this.props;
    const { isValid } = this.state;
    const asyncDisqualify = !isValid
      ? isValid
      : form.values[field.name] !== undefined &&
        form.errors[field.name] !== undefined &&
        form.values[field.name].length === 4;

    return (
      <QualifyingField
        errors={form.errors}
        name={field.name}
        isValid={asyncDisqualify}
        marginTopOffset={marginTopOffset}
        disqualificationMessage={disqualificationMessage}
        recordDisqualification={recordDisqualification}
      >
        <input name={field.name} value={field.value} type={'hidden'} />
      </QualifyingField>
    );
  }
}

export { HiddenField as default };
